import { BsCalendar3, BsStars } from 'react-icons/bs';

import Button from '#globalComponents/Button/Button';

import { CUSTOM_DESIGN_BOOKING_URL, CUSTOM_DESIGN_IMAGE_URL } from '../../constants/customDesign';

/**
 * Promo banner under the starter gallery: offers individually designed mailings via a booked intro call.
 */
export default function CustomDesignCta() {
	return (
		<aside className="pm-custom-cta">
			<div className="pm-custom-cta__media">
				<img
					src={CUSTOM_DESIGN_IMAGE_URL}
					alt="Beispiel für ein individuell gestaltetes Mailing"
					loading="lazy"
				/>
			</div>

			<div className="pm-custom-cta__content">
				<span className="pm-custom-cta__eyebrow">
					<BsStars size={14} />
					Individuelles Design
				</span>
				<h3 className="pm-custom-cta__title">Lieber ein maßgeschneidertes Mailing?</h3>
				<p className="pm-custom-cta__text">
					Wir gestalten Ihr Post-Mailing individuell — passend zu Ihrer Marke und Kampagne. Vereinbaren Sie
					einfach ein kurzes Gespräch, und wir besprechen Ihr Wunschdesign.
				</p>

				<div className="pm-custom-cta__actions">
					<Button variant="solid" href={CUSTOM_DESIGN_BOOKING_URL} target="_blank">
						<BsCalendar3 size={16} />
						Gespräch vereinbaren
					</Button>
				</div>
			</div>
		</aside>
	);
}
